import React, { useState, useRef, useEffect } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';

function CollapsibleSection({ title, children, defaultExpanded = false }) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const wrapperRef = useRef(null);

  // Klick außerhalb + ESC schließt
  useEffect(() => {
    if (!expanded) return;

    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setExpanded(false);
    };

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [expanded]);

  return (
    <div className="collapsible-section" ref={wrapperRef}>
      <button
        className="collapsible-button"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
        aria-controls={`section-${title}`}
      >
        {expanded ? <FaMinus /> : <FaPlus />} {title}
      </button>
      {expanded && (
        <div className="collapsible-content" id={`section-${title}`}>
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
